import { render, staticRenderFns } from "./StudioCommunityFeed.vue?vue&type=template&id=09f8eac8&scoped=true&"
import script from "./StudioCommunityFeed.vue?vue&type=script&lang=ts&"
export * from "./StudioCommunityFeed.vue?vue&type=script&lang=ts&"
import style0 from "./StudioCommunityFeed.vue?vue&type=style&index=0&id=09f8eac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f8eac8",
  null
  
)

export default component.exports